import { FC } from 'react'
import { InputThemeType, InputThemeContext } from 'components/features/theme/InputThemeContext'
import { useInputTheme } from 'components/features/theme/useInputTheme'

type ThemeProviderProps =
  & Partial<InputThemeType>
  & {
  }
export const ThemeProvider: FC<ThemeProviderProps> = (props) => {
  const { children, ...restProps } = props

  const context = useInputTheme()

  return (
    <InputThemeContext.Provider value={{ ...context, ...restProps }}>
      { children }
    </InputThemeContext.Provider>
  )
}
